angular.module('mercury.modules.reports.reconciliations')
.controller('ReportsReconciliationCashupsCtrl', ["CashupSets", "$filter", "$scope", "$q", "reporttime", "title", function(CashupSets, $filter, $scope, $q, reporttime, title) {
  title.set('Cashups Report');

  $scope.cashupCols = [
    {label: 'Tender Type', type: 'string', key: 'tenderName'},
    {label: 'Actual Amount', type: 'number', key: 'countedAmount', filter: 'currency'}
  ];

  $scope.showTotalsTable = reporttime.reportType() !== 'day';

  $scope.loading = CashupSets.get(reporttime.start(), reporttime.end());
  $scope.loading.then(function(result) {
    var setLinesMap = {};
    var totalsMap = {};
    angular.forEach(result, function(cashupSet) {
      setLinesMap[cashupSet.id] = {};

      angular.forEach(cashupSet.cashups, function(cashup) {
        angular.forEach(cashup.lines, function(cashupLine) {
          if (cashupLine.countedAmount === 0 && cashupLine.systemAmount === 0) {
            return;
          }

          if (setLinesMap[cashupSet.id][cashupLine.tenderTypeId]) {
            setLinesMap[cashupSet.id][cashupLine.tenderTypeId].countedAmount += cashupLine.countedAmount;
            setLinesMap[cashupSet.id][cashupLine.tenderTypeId].systemAmount += cashupLine.systemAmount;
          } else {
            setLinesMap[cashupSet.id][cashupLine.tenderTypeId] = {
              tenderName: cashupLine.tenderTypeName,
              countedAmount: cashupLine.countedAmount,
              systemAmount: cashupLine.systemAmount
            };
          }

          setLinesMap[cashupSet.id][cashupLine.tenderTypeId].variance = setLinesMap[cashupSet.id][cashupLine.tenderTypeId].countedAmount -
            setLinesMap[cashupSet.id][cashupLine.tenderTypeId].systemAmount;

          if (totalsMap[cashupLine.tenderTypeId]) {
            totalsMap[cashupLine.tenderTypeId].countedAmount += cashupLine.countedAmount;
            totalsMap[cashupLine.tenderTypeId].systemAmount += cashupLine.systemAmount;
          } else {
            totalsMap[cashupLine.tenderTypeId] = {
              tenderName: cashupLine.tenderTypeName,
              countedAmount: cashupLine.countedAmount,
              systemAmount: cashupLine.systemAmount
            };
          }

          totalsMap[cashupLine.tenderTypeId].variance = totalsMap[cashupLine.tenderTypeId].countedAmount -
            totalsMap[cashupLine.tenderTypeId].systemAmount;
        });
      });

      $scope.setLines = {};
      angular.forEach(setLinesMap, function(setLines, index) {
        var setLinesArray = [];
        angular.forEach(setLines, function(tenderLine) {
          setLinesArray.push(tenderLine);
        });
        $scope.setLines[index] = setLinesArray;
      });

      $scope.totalLines = [];
      angular.forEach(totalsMap, function(tenderTotal) {
        $scope.totalLines.push(tenderTotal);
      });

      $scope.cashupSets = result;
    });
  });
}]);
